import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Typography,
    IconButton,
    Paper,
    CircularProgress
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import apiUrl from '../../Config';

const DisplayRadius = () => {
    const [radius, setRadius] = useState({});
    const navigate = useNavigate();
    const [errors, setErrors] = useState('')
    const [loading, setLoading] = useState(false)

    const getAllRadius = async () => {

        try {
            setLoading(true)
            const res = await axios.get(`${apiUrl}/radiussetting/getradius`);
            if (res?.data?.status === true) {

                setRadius(res?.data?.radiusKm);
            }
        } catch (error) {
            setErrors(error?.res?.data?.message || "Error fetching radius")
        }
        finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        getAllRadius();
    }, []);

    const handleEdit = (item) => {
        navigate('/create-edit-radius', { state: { item } });
    };

    return (
        <>

            <Paper elevation={3} sx={{ m: 2, p: 2, maxWidth: 500, mt: 3, mr: 'auto' }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="h5" fontWeight="bold">
                        Delivery Radius
                    </Typography>
                </Box>

                {loading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" minHeight="150px">
                        <CircularProgress />
                    </Box>
                ) : (
                    <Box>
                        {Array.isArray(radius) && radius.length > 0 ? (
                            radius.map((item) => (
                                <Paper key={item.id} elevation={2} sx={{ p: 2, mb: 2 }}>
                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                        <Box>
                                            <Typography variant="subtitle1">
                                                <strong>Range For:</strong> {item.rangeFor}
                                            </Typography>
                                            <Typography variant="subtitle1">
                                                <strong>Radius:</strong> {item.radiusKm} Km
                                            </Typography>
                                        </Box>
                                        <IconButton color="primary" onClick={() => handleEdit(item)}>
                                            <EditIcon />
                                        </IconButton>
                                    </Box>
                                </Paper>
                            ))
                        ) : (
                            <Typography>No radius data available</Typography>
                        )}


                    </Box>
                )}
            </Paper>

            {errors &&

                <Typography variant='body2' color='error'>{errors}</Typography>

            }


        </>
    );
};

export default DisplayRadius;
